import { useEffect, useRef, useState } from "react";
import API_URL from "../../config/api";
import Header, { Footer } from "../HomePage/header";
import { useNotification } from "../Notification/notification";
import "./servicePage.css";

export default function ServicePage() {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [contactNumber, setContactNumber] = useState("");

  const { notify } = useNotification();

  useEffect(() => {
    fetch(`${API_URL}/api/services`)
      .then((res) => res.json())
      .then((data) => setServices(Array.isArray(data) ? data : []))
      .catch(() => notify("Failed to load services", "error"));
  }, []);

  const handleDateChange = (e) => {
    const value = e.target.value;
    setSelectedDate(value);

    const day = new Date(value).toLocaleDateString("en-US", {
      weekday: "long",
    });

    setSelectedDay(day);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) setImage(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (!selectedService || !selectedType || !selectedDate || !contactNumber) {
      notify("Please fill required fields", "warning");
      return;
    }

    try {
      await fetch(`${API_URL}/api/service-requests`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          serviceId: selectedService.id,
          serviceName: selectedService.name,
          type: selectedType,
          date: selectedDate,
          day: selectedDay,
          contactNumber,
          description,
        }),
      });

      notify("Service request submitted", "success");

      setSelectedService(null);
      setSelectedType("");
      setSelectedDate("");
      setSelectedDay("");
      setDescription("");
      setImage(null);
      setContactNumber("");
    } catch (err) {
      notify("Failed to submit", "error");
    }
  };

  const lastScrollY = useRef(0);
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsCompact(window.scrollY > lastScrollY.current && window.scrollY > 50);
      lastScrollY.current = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <Header isCompact={isCompact} />

      <div className="main-containers">
        {services.map((service) => (
          <div
            key={service.id}
            className="box"
            onClick={() => setSelectedService(service)}
          >
            <img
              src={service.image || "https://dummyimage.com/150"}
              className="service-image"
            />
            <h2>{service.name}</h2>
          </div>
        ))}
      </div>

      {selectedService && (
        <div className="overlay" onClick={() => setSelectedService(null)}>
          <div
            className="service-form-overlay"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>{selectedService.name}</h2>

            {/* SERVICE TYPE */}
            <div className="form-full">
              <label>Service Type</label>
              <select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="New">New</option>
                <option value="Repair">Repair</option>
                <option value="Consultation">Consultation</option>
              </select>
            </div>

            {/* CONTACT + DATE */}
            <div className="form-row">
              <div className="form-col">
                <label>Contact Number</label>
                <input
                  value={contactNumber}
                  onChange={(e) => setContactNumber(e.target.value)}
                />
              </div>

              <div className="form-col">
                <label>Select Date</label>
                <input type="date" onChange={handleDateChange} />
              </div>
            </div>

        
            <div className="day-image-row">
              <div className="day-box">
                <label>Day</label>
                <input value={selectedDay} readOnly />
              </div>
              <div className="image-box">
                <label>Upload Image</label>

                <div
                  className="upload-box"
                  onClick={() => document.getElementById("fileUpload").click()}
                >
                  <input
                    type="file"
                    id="fileUpload"
                    onChange={handleImageUpload}
                  />

                  {!image && (
                    <span className="upload-placeholder">Click to upload</span>
                  )}

                  {image && (
                    <img src={image} alt="preview" className="upload-preview" />
                  )}
                </div>
              </div>
            </div>

            {/* DESCRIPTION */}
            <div className="form-full">
              <label>Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <button className="btn" onClick={handleSubmit}>
              Book Service
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
